import {RelationshipDefinition} from "./relationship-definition";
import {TableModel} from "../table/table-model";
import {FieldDefinition} from "../field/field-definition";

export class RelationshipModel {

  private readonly definition: RelationshipDefinition;
  private readonly parent: TableModel;

  constructor(definition: RelationshipDefinition, parent: TableModel) {
    this.definition = definition;
    this.parent = parent;
  }

  getTableName(): string {
    return this.parent?.getTableName();
  }

  getTableModel(): TableModel {
    return this.parent;
  }

  getID() {
    return this.getDefaultedField("_id");
  }

  getName() {
    return this.getDefaultedField("_fieldName");
  }

  getParentTableName() {
    return this.getDefaultedField("_parentTable");
  }

  getSourceTable() {
    return this.getDefaultedField("_sourceTable");
  }

  getTargetTable() {
    return this.getDefaultedField("_targetTable");
  }

  getReverseRelationName() {
    return this.getDefaultedField("_reverseRelationName");
  }

  getDisplayValue() {
    return this.getDefaultedField("_displayValue");
  }

  getRelationshipType() {
    return this.getDefaultedField("_relationshipType");
  }

  isInherited() {
    return this.getDefaultedField("_inherited", false);
  }

  isUnique() {
    return this.getDefaultedField("_unique", false);
  }

  getProperty(propertyName: string) {
    return this.getDefaultedField("_properties", {})[propertyName];
  }

  getI18nKey() {
    return this.getDefaultedField("_i18nKey");
  }

  getPrefixIcon() {
    return this.getDefaultedField("_prefixIcon");
  }

  getPlaceHolderI18nKey() {
    return this.getDefaultedField("_placeholderI18nKey");
  }

  isRequired() {
    return this.getDefaultedField("_required", false);
  }

  isReadOnly() {
    return this.getDefaultedField("_readOnly", false);
  }

  getRenderer() {
    return this.getDefaultedField("_renderer");
  }

  getRendererProperties() {
    return this.getDefaultedField("_rendererProperties", {});
  }

  getQueryRenderer() {
    return this.getDefaultedField("_queryRenderer");
  }

  getQueryRendererProperties() {
    return this.getDefaultedField("_queryRendererProperties", {});
  }

  getRelationshipDefinition(): RelationshipDefinition {
    return this.definition;
  }

  private getDefaultedField(property: any, defaultValue?: any) {
    const value = this.definition[property];
    return value !== null && value !== undefined ? value : defaultValue;
  }

  static create(definition: RelationshipDefinition, parent: TableModel): RelationshipModel {
    return new RelationshipModel(definition, parent);
  }

  static FIELD_TYPES = {
    REFERENCE         : "reference",
    UNIQUE_REFERENCE  : "unique_reference",
    MANY_TO_ONE       : "many_to_one",
    ONE_TO_ONE        : "one_to_one",
    MANY_TO_MANY      : "many_to_many",
    GENERIC_REFERENCE : "generic_reference",
    GENERIC_REFERENCE_V2 : "generic_reference_v2"
  };

}
